import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import {useSettingsContext} from '../../context/settings/useSettingsContext';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import DateUtils from '../../utils/DateUtils';

const Links = styled.div`
    @media (max-width: 768px) {
        && {
            flex-wrap: wrap;
            //justify-content: flex-start;
        }
    }
`

const ButtonLink = styled.a.attrs({
    className: 'cr-pill cr-border-primary cr-text-primary',
})`
    text-align: left;
`

const AlertButtonLink = styled.a.attrs({
    className: 'cr-pill cr-text-white cr-bg-alert',
})`
    text-align: left;
`

type TProps = {
    details: IOnlineCondolenceDetails;
}

const ActionLinks = ({details}: TProps) => {
    const {t} = useTranslation();
    const { sendFlowersUrl } = useSettingsContext();

    const showMourningMessage =
        details.mourningMessageFileUrl
        && DateUtils.isNowBetween(details.mourningMessageFileVisibleFrom)
    ;

    const showObituary =
        details.obituaryFileUrl
        && DateUtils.isNowBetween(details.obituaryFileVisibleFrom)
    ;

    const showMemorialCard =
        details.memorialCardFileUrl
        && DateUtils.isNowBetween(details.memorialCardFileVisibleFrom)
    ;

    const hasLinks = (
        sendFlowersUrl
        || showMourningMessage
        || showObituary
        || showMemorialCard
        || details.donationUrl
        || details.liveStreamUrl
    );

    return hasLinks ? (
        <Links className="cr-flex cr-gap cr-center cr-px-lg cr-py">
            {showMourningMessage
                && <ButtonLink href={details.mourningMessageFileUrl}>{t('mourning-card')}</ButtonLink>
            }{showObituary
                && <ButtonLink href={details.obituaryFileUrl}>{t('obituary-card')}</ButtonLink>
            }
            {showMemorialCard
                && <ButtonLink href={details.memorialCardFileUrl}>{t('memorial-card')}</ButtonLink>
            }
            {sendFlowersUrl
                && <ButtonLink href={sendFlowersUrl}>{t('send-flowers')}</ButtonLink>
            }
            {details.donationUrl
                && <ButtonLink href={details.donationUrl}>{t('donate')}</ButtonLink>
            }
            {details.liveStreamUrl
                && <AlertButtonLink href={details.liveStreamUrl}>{t('view-livestream')}</AlertButtonLink>
            }
        </Links>
    ) : null;
}

export default ActionLinks;
